import { render } from "./DownloadsView.vue?vue&type=template&id=c0091884&ts=true"
import script from "./DownloadsView.vue?vue&type=script&lang=ts"
export * from "./DownloadsView.vue?vue&type=script&lang=ts"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__